/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import { ROOT_SLICE } from './constants';
import {
	selectCustomers as customersSelectCustomers,
	selectCombinedEntitiesData,
	selectIsOutOfSync
} from '../CustomersV2/selectors';
import PSQL_APPLICATIONS from '../Sync/PsqlCustomersApplications/selectors';
import DDB_CUSTOMERS from '../Sync/DdbCustomers/selectors';
import PSQL_CUSTOMERS from '../Sync/PsqlCustomers/selectors';
import PSQL_AREAS from '../Sync/PsqlCustomerAreas/selectors';
import PSQL_PIPES from '../Sync/PsqlCustomerPipes/selectors';
import PSQL_REG_STATUS from '../Sync/PsqlCustomerRegulatoryStatus/selectors';
import DDB_CUSTOMER_SETTINGS from '../Sync/DdbCustomersSettings/selectors'
import { store } from '../../../../scanline/store';

export const selectRootSlice = stateAdmin => stateAdmin[ROOT_SLICE];

export const selectSearchText = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { searchText } = slice;
	return searchText;
};

export const selectCustomers = createSelector(
	customersSelectCustomers,
	selectSearchText,
	PSQL_APPLICATIONS.selectData,
	// eslint-disable-next-line no-unused-vars
	(customers = [], paramSearchText = '', _psqlApplicationsData = []) => {
		const searchText = paramSearchText.toLowerCase().trim();
		if (!paramSearchText) {
			return customers;
		}

		const stateAdmin = store.getState().Admin;

		return customers.filter((c = '') => {
			const name = c.toLowerCase();
			const applications = (
				PSQL_APPLICATIONS.selectDataByCustomer(stateAdmin, {
					customer: c
				}) || []
			).map(a => a.toLowerCase());
			const isOutOfSync = selectIsOutOfSync(stateAdmin, { customer: c });

			const matcherParts = [name, ...applications];
			if (isOutOfSync) {
				matcherParts.push('outofsync');
			}

			if (applications.length === 0) {
				matcherParts.push('missingapplications');
			}

			const matchers = matcherParts.join(' ');

			const matches = matchers.indexOf(searchText) > -1;

			return matches;
		});
	}
);


const SETTING_APP_KEYS = {
	ADMIN: 'ADMIN',
	ASSETVIEW: 'ASSETVIEW',
	SCANLINE: 'SCANLINE',
}
const settingsToString = (customerSettings, appKey) => {
	const settings = customerSettings[appKey] || {};
	const keys = Object.keys(settings);
	return keys.reduce((acc, prop) => { 
		acc.push(`${prop}: ${settings[prop]}`);
		return acc;
	}, []).join(', ');
}

export const selectCustomersForDownload = createSelector(
	selectCustomers,
	DDB_CUSTOMERS.selectDomainMap,
	PSQL_CUSTOMERS.selectDataMap,
	PSQL_APPLICATIONS.selectData,
	selectCombinedEntitiesData,
	PSQL_AREAS.selectData,
	PSQL_PIPES.selectData,
	PSQL_REG_STATUS.selectData,
	DDB_CUSTOMER_SETTINGS.selectData,
	(customers = [], domainMap = {}, psqlCustomersMap = {}, applicationsMap = {}, entities = {}, areas = {}, pipes = {}, regstatuses = {}, allSettings = {}) => {
		return customers.map(c => ({
			name: c,
			domain: domainMap[c],
			job_number_prefix: psqlCustomersMap[c]?.customerCreatedJobNumberPrefix,
			applications: (applicationsMap[c] || []).join(', '),
			entities: (entities[c] || []).join(', '),
			areas: (areas[c] || []).map(o => o.name).join(', '),
			pipes: (pipes[c] || []).map(o => o.name).join(', '),
			reg_statuses: (regstatuses[c] || []).map(o => o.name).join(', '),
			admin_settings: settingsToString((allSettings[c] || {}), SETTING_APP_KEYS.ADMIN),
			assetview_settings: settingsToString((allSettings[c] || {}), SETTING_APP_KEYS.ASSETVIEW),
			scanline_settings: settingsToString((allSettings[c] || {}), SETTING_APP_KEYS.SCANLINE),
			isOutOfSync:
				selectIsOutOfSync(store.getState().Admin, { customer: c }) || undefined
		}));
	}
);
